export const CSSISearchTypes = {
  upc: 'upc_codes',
  ccsi_id: 'item_ids',
  manufacturer_id: 'manufacturer_ids',
};

export class CSSI_Item {
  cssi_id: string;
  upc: string;
  custom_price: number;
  in_stock_flag: number;
  serialized_flag: number;
  ffl_flag: number;
  inventory: number;
  map_price: string;
  name: string;
  retail_price: number;
  drop_ship_flag: number;
  drop_ship_price: number;
  available_drop_ship_delivery_options: string;
}
export class CSSI_Paginaton {
  per_page: number;
  page_count: number;
  page: number;
}
export class CSSI_Response {
  items: CSSI_Item[];
  pagination: CSSI_Paginaton;
}
export class CSSI_Error_Response {
  error_code: number;
  errors: [
    {
      message: string;
      property: string;
      subcode: number;
    }
  ];
  message: string;
}
